/**
 * Cross-tab "last activity" timestamp, backed by localStorage.
 *
 * localStorage is shared across same-origin tabs, so writing here from one
 * tab and listening for the native `storage` event in another is how
 * useIdleTimeout keeps idle tracking in sync across tabs without a
 * dedicated BroadcastChannel.
 */

export const IDLE_ACTIVITY_STORAGE_KEY = 'piranha:lastActivityAt'

export const getLastActivityAt = (): number => {
  try {
    const stored = localStorage.getItem(IDLE_ACTIVITY_STORAGE_KEY)
    const parsed = stored === null ? NaN : Number(stored)
    return Number.isFinite(parsed) ? parsed : Date.now()
  } catch {
    // localStorage may be unavailable (e.g. cookies blocked, private mode);
    // treat as "just active" rather than blocking idle tracking entirely.
    return Date.now()
  }
}

export const setLastActivityAt = (timestamp: number): void => {
  try {
    localStorage.setItem(IDLE_ACTIVITY_STORAGE_KEY, String(timestamp))
  } catch {
    // Cross-tab sync degrades gracefully to per-tab-only tracking.
  }
}

export const clearLastActivityAt = (): void => {
  try {
    localStorage.removeItem(IDLE_ACTIVITY_STORAGE_KEY)
  } catch {
    // localStorage may be unavailable; nothing to clean up in that case.
  }
}
